import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SettingsSliders = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M20 3V6.1C17.725 6.563 16 8.587 16 11C16 13.413 17.725 15.438 20 15.9V29C20 29.55 20.45 30 21 30C21.55 30 22 29.55 22 29V15.9C24.275 15.437 26 13.413 26 11C26 8.587 24.275 6.562 22 6.1V3C22 2.45 21.55 2 21 2C20.45 2 20 2.45 20 3V3ZM24 11C24 12.65 22.65 14 21 14C19.35 14 18 12.65 18 11C18 9.35 19.35 8 21 8C22.65 8 24 9.35 24 11Z" />
		<path d="M12 29V25.9C14.275 25.438 16 23.412 16 21C16 18.588 14.275 16.562 12 16.1V3C12 2.45 11.55 2 11 2C10.45 2 10 2.45 10 3V16.1C7.725 16.562 6 18.588 6 21C6 23.412 7.725 25.438 10 25.9V29C10 29.55 10.45 30 11 30C11.55 30 12 29.55 12 29ZM8 21C8 19.35 9.35 18 11 18C12.65 18 14 19.35 14 21C14 22.65 12.65 24 11 24C9.35 24 8 22.65 8 21Z" />
	</svg>
);

export default SettingsSliders;
